// extracted by mini-css-extract-plugin
export default {"container":"zZxoXarMpv","uplink":"_1Na2U76UDC","downlink":"_3ae3CwyWLt","policy":"_1jQRFr32oV","icon":"_2lVeYiKg8G"};
    if(module.hot) {
      // 1625219472973
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  